module.exports = __webpack_public_path__ + "img/real-person-icon.7a34ebc7.png";